import { Box, Typography, Button, Grid } from '@mui/material';
import { ReactComponent as FundraiserSteps } from '../../../../../../assets/svg/step.svg';
import COLORS from '../../../../../../constants/colors';
import { FaRegUserCircle } from 'react-icons/fa';
import { MdOutlineCreate, MdOutlineShare } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../../../../../Reusable/Button';


const steps = [
    { number: 1, title: 'Sign Up or Log In', description: 'Create an account or log in to get started.', icon: <FaRegUserCircle size={28} color={COLORS.primary} /> },
    { number: 2, title: 'Create Your Fundraiser', description: 'Fill in key details like the fundraiser title, description, category, and fundraising goal. Upload a photo or video to make it more compelling.', icon: <MdOutlineCreate size={28} color={COLORS.primary} /> },
    { number: 3, title: 'Share and Start Receiving Donations', description: 'Once your fundraiser is set up, share it with friends and family via social media or direct link. Start receiving donations and track your progress in real time!', icon: <MdOutlineShare size={28} color={COLORS.primary} /> }
];

const ThreeStepGuide = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ textAlign: 'left', py: 10, px: 3, maxWidth: 1200, margin: '0 auto' }}>
            <Typography variant="h4" fontWeight="bold" color={COLORS.primary} mb={6} textAlign="center">
                Your dream could be only <span style={{ color: COLORS.secondary }}>1, 2, 3 steps away</span>
            </Typography>

            <Grid container spacing={6} alignItems="center">
                <Grid item xs={12} md={6}>
                    {steps.map((step, index) => (
                        <Box key={index} display="flex" alignItems="center" mb={5}>
                            <Box
    sx={{
        minWidth: 50, // Ensures uniform size
        minHeight: 50, // Ensures uniform size
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.3rem',
        fontWeight: 'bold',
        mr:2,
        color: COLORS.primary,
        border: `3px solid ${COLORS.accent}`,
        backgroundColor: COLORS.white,
        boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.3s ease-in-out, border-color 0.3s',
        '&:hover': {
            transform: 'scale(1.1)',
            borderColor: COLORS.secondary
        }
    }}
>
    {step.number}
</Box>

                            <Box>
                                <Typography variant="h6" fontWeight="bold" color={COLORS.primary} mb={0.5}>
                                    {step.title}
                                </Typography>
                                <Typography variant="body1" color={COLORS.text} mb={1.5}>
                                    {step.description}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                    <PrimaryButton  onClick={() => navigate('/user/register')}>
                    

               
                   Start a Fundraiser
                </PrimaryButton> 
                </Grid>
                <Grid item xs={12} md={6} display="flex" justifyContent="center">
                    <Box sx={{ maxWidth: { xs: '100%', md: '80%' }, height: 'auto', borderRadius: 3 }}>
                        <FundraiserSteps width="100%" height="auto" />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ThreeStepGuide;
